import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EInternetStatus } from '../../actions/internetStatus';
import { retrySendMessage } from '../../actions/sendMessage';
import { openEventChannel } from '../../actions/socket';
import { IMessageEvent } from '../../actions/wsMessage/types';
import { ChatWindowError } from '../../components/ChatWindowError';
import { socketSelector, internetStatusSelector, currentOpenChatSelector } from '../../selectors';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { EDeviceType } from '../../types/deviceType';

export const ChatWindowErrorContainer: React.FC = () => {
  const internetStatus = useSelector(internetStatusSelector);
  const { status: socketStatus, clientEvents } = useSelector(socketSelector);
  const currentChat = useSelector(currentOpenChatSelector);

  const { chatId, status } = currentChat || {};

  const isOffline = internetStatus === EInternetStatus.Offline;
  const isMessagesNotFound = status === ERequestApiStatus.Failed;
  const values = clientEvents && clientEvents.values();
  let errorNode: React.ReactNode = null;

  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const dispatch = useDispatch();

  const hasRetryMessages = React.useMemo(() => {
    if (values) {
      for (const entry of values) {
        const { status, type, chatId: eventChatId } = entry as IMessageEvent;
        if (status === ERequestApiStatus.Failed && type === EWsClientEventType.Message && eventChatId === chatId) {
          return true;
        }
      }
    }

    return false;
  }, [chatId, values]);

  const handleRetrySendMessage = React.useCallback(() => {
    dispatch(retrySendMessage(chatId as string));
  }, [chatId, dispatch]);

  const handleRetrySocket = React.useCallback(() => {
    dispatch(openEventChannel());
  }, [dispatch]);

  if (hasRetryMessages) {
    errorNode = <ChatWindowError text="Не удалось отправить сообщения." onRetry={handleRetrySendMessage} />;
  }

  if (isMessagesNotFound) {
    errorNode = <ChatWindowError text="Не удалось загрузить сообщения" />;
  }

  if (socketStatus === ERequestApiStatus.Failed) {
    errorNode = <ChatWindowError text="Сервер не отвечает." onRetry={handleRetrySocket} />;
  }

  if (isOffline) {
    const text = isMobile ? 'Сервер не отвечает' : 'Сервер не отвечает, попробуйте чуть позже';

    errorNode = <ChatWindowError text={text} />;
  }

  return errorNode;
};
